/**
 * Permission constants for consistent use across the application
 * These match the backend permission format: {action}:{resource}
 */
export const PERMISSIONS = {
  // Artifact permissions
  READ_ARTIFACTS: 'read:artifacts',
  WRITE_ARTIFACTS: 'write:artifacts',
  DELETE_ARTIFACTS: 'delete:artifacts',
  
  // Process permissions
  READ_PROCESSES: 'read:processes',
  WRITE_PROCESSES: 'write:processes',
  DELETE_PROCESSES: 'delete:processes',
  
  // Thread permissions
  READ_THREADS: 'read:threads',
  WRITE_THREADS: 'write:threads',
  DELETE_THREADS: 'delete:threads',
  
  // Command permissions
  EXECUTE_COMMANDS: 'execute:commands',
  ADMIN_COMMANDS: 'admin:commands',
  
  // User management permissions
  MANAGE_USERS: 'manage:users',
  MANAGE_ROLES: 'manage:roles',
  
  // System permissions
  SYSTEM_ADMIN: 'system:admin',
  VIEW_ANALYTICS: 'view:analytics',
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

/**
 * Role constants for consistent use across the application
 * Matches backend role hierarchy: superuser > admin > architect > manager > user > operator > viewer
 */
export const ROLES = {
  SUPERUSER: 'superuser',
  ADMIN: 'admin',
  ARCHITECT: 'architect',
  MANAGER: 'manager',
  USER: 'user',
  OPERATOR: 'operator',
  VIEWER: 'viewer',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];

/**
 * Role hierarchy for permission inheritance
 * Higher roles inherit permissions from lower roles
 */
export const ROLE_HIERARCHY: Record<Role, number> = {
  [ROLES.SUPERUSER]: 7,
  [ROLES.ADMIN]: 6,
  [ROLES.ARCHITECT]: 5,
  [ROLES.MANAGER]: 4,
  [ROLES.USER]: 3,
  [ROLES.OPERATOR]: 2,
  [ROLES.VIEWER]: 1,
};
